import { render, staticRenderFns } from "./InterventionReassignEmployeEdit.vue?vue&type=template&id=32a2b3bd"
import script from "./InterventionReassignEmployeEdit.vue?vue&type=script&lang=ts"
export * from "./InterventionReassignEmployeEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports